import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../api';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await api.post('/auth/forgot-password', { email });
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Something went wrong');
    }
    setLoading(false);
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(135deg, var(--cream), rgba(232,160,191,0.1))', padding: '20px' }}>
      <div style={{ maxWidth: '420px', width: '100%' }}>
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <Link to="/" style={{ display: 'inline-block' }}>
            <img src="/ggr-logo-deck.png" alt="Grand Gather Registry" style={{ height: '160px', maxWidth: '280px', objectFit: 'contain', marginBottom: '8px' }} />
          </Link>
        </div>
        <div className="card" style={{ padding: '40px' }}>
          {sent ? (
            <div style={{ textAlign: 'center' }}>
              <div style={{ width: '56px', height: '56px', borderRadius: '50%', background: 'rgba(16,185,129,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px' }}>
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#10B981" strokeWidth="2"><path d="M22 11.08V12a10 10 0 11-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>
              </div>
              <h2 style={{ fontSize: '22px', marginBottom: '12px' }}>Check Your Email</h2>
              <p style={{ color: 'var(--gray)', fontSize: '14px', lineHeight: 1.6, marginBottom: '20px' }}>
                If an account with <strong>{email}</strong> exists, we've sent a password reset link. Check your inbox (and spam folder).
              </p>
              <Link to="/login" className="btn btn-primary btn-full" style={{ textDecoration: 'none', display: 'block', textAlign: 'center' }}>Back to Sign In</Link>
            </div>
          ) : (
            <>
              <h2 style={{ marginBottom: '8px', textAlign: 'center', fontSize: '22px' }}>Forgot Password?</h2>
              <p style={{ textAlign: 'center', color: 'var(--gray)', fontSize: '14px', marginBottom: '24px', lineHeight: 1.5 }}>
                Enter your email and we'll send you a link to reset your password.
              </p>
              {error && <div style={{ padding: '12px', background: 'rgba(239,68,68,0.1)', borderRadius: '8px', color: 'var(--red)', marginBottom: '16px', fontSize: '14px' }}>{error}</div>}
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label>Email Address</label>
                  <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="your@email.com" required autoFocus />
                </div>
                <button type="submit" className="btn btn-primary btn-full btn-lg" disabled={loading} style={{ marginTop: '8px' }}>
                  {loading ? 'Sending...' : 'Send Reset Link'}
                </button>
              </form>
              <p style={{ textAlign: 'center', marginTop: '20px', fontSize: '14px', color: 'var(--gray)' }}>
                Remember your password? <Link to="/login" style={{ color: 'var(--gold-dark)', fontWeight: 600 }}>Sign In</Link>
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
